import { Component, OnInit } from '@angular/core';
import {Store} from "@ngrx/store";
import * as fromStore from '../../../../../../../store';
import {ActivatedRoute} from "@angular/router";
import {FormControl, FormGroup} from "@angular/forms";
import {DbResponse} from "../../../../../../../shared/interceptors/db-response";
import {NotifierComponent} from "../../../../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../../../../shared/components/notifier/notification-type";
import {CloudflareService} from "../../../../services/cloudflare.service";
import {filter, first, map, takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";
import {GoogleAnalyticsService} from "../../../../../../../shared/services/google-analytics/google-analytics.service";

@Component({
    selector: 'db-cdn-full-page-cache-settings',
    templateUrl: './cdn-full-page-cache-settings.component.html',
    styleUrls: ['./cdn-full-page-cache-settings.component.scss'],
    standalone: false
})
export class CdnFullPageCacheSettingsComponent implements OnInit {

  public websiteId: number;
  public loading: boolean;
  public disableCdn: boolean = true;
  public disablePageCache: boolean = true;
  public bypassPageUrlRegex: any;
  public bypassCookie: any;
  public includeQueryString: any;
  public settingsForm: FormGroup;
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private readonly _store: Store<fromStore.DbStoreState>,
    private readonly _route: ActivatedRoute,
    private _cloudflareService: CloudflareService,
    private _googleAnalyticsService: GoogleAnalyticsService,
  ) { }

  ngOnInit() {
    this.websiteId = +this._route.snapshot.parent.parent.params['id'];
    this.settingsForm = new FormGroup({
      'bypassPageUrlRegex': new FormControl(''),
      'bypassCookie': new FormControl(''),
      'includeQueryString': new FormControl('')
    });
    this._getCloudflareData();
/*    this._getCloudFlareFullPageCacheDisabled();
    this._getCloudFlareEnterPriseDisabled();
    this._getCloudFlareSettingsValues();*/
  }

  private _getCloudflareData(): void {
    this._store.select(fromStore.getCloudflareData(this.websiteId))
      .pipe(
        takeUntil(this._destroyStream$),
        filter(({cacheRules}) => !!cacheRules),
        map(({cacheRules}) => cacheRules),
      )
      .subscribe(({disableCdn, disablePageCache, bypassPageUrlRegex, bypassCookie, includeQueryString}) => {
        this.disableCdn = disableCdn;
        this.disablePageCache = disablePageCache;
        this._setValues(bypassPageUrlRegex, bypassCookie, includeQueryString);
      });
  }

  private _setValues(bypassPageUrlRegex, bypassCookie, includeQueryString): void {
    this.bypassPageUrlRegex = bypassPageUrlRegex.join('\r\n');
    this.bypassCookie = bypassCookie.join('\r\n');
    this.includeQueryString = includeQueryString.join('\r\n');
    this.settingsForm.controls['bypassPageUrlRegex'].setValue(this.bypassPageUrlRegex);
    this.settingsForm.controls['bypassCookie'].setValue(this.bypassCookie);
    this.settingsForm.controls['includeQueryString'].setValue(this.includeQueryString);
  }

  /*private _getCloudFlareFullPageCacheDisabled(): void {
    this._store.select(fromStore.getCloudFlareFullPageCacheDisabled(this.websiteId))
      .pipe(
        takeUntil(this._destroyStream$),
      )
      .subscribe(state => {
        this.disablePageCache = !!state;
      });
  }*/

  /*private _getCloudFlareEnterPriseDisabled(): void {
    this._store.select(fromStore.getCloudFlareEnterPriseDisabled(this.websiteId))
      .pipe(
        takeUntil(this._destroyStream$),
      )
      .subscribe(state => {
        this.disableCdn = !!state;
      })
  }

  private _getCloudFlareSettingsValues(): void {
    this._store.select(fromStore.getCloudFlareSettingsValues(this.websiteId))
      .pipe(
        takeUntil(this._destroyStream$),
        filter(settingsValues => !!settingsValues)
      )
      .subscribe(state => {
        this._setValues(state.bypassPageUrlRegex, state.bypassCookie, state.includeQueryString);
      });
  }*/

  public save(): void {
    this.loading = true;
    const settingsValues = {
      bypassCookie: this.settingsForm.value.bypassCookie && this.settingsForm.value.bypassCookie.split(/\r?\n/) || [],
      bypassPageUrlRegex: this.settingsForm.value.bypassPageUrlRegex && this.settingsForm.value.bypassPageUrlRegex.split(/\r?\n/) || [],
      includeQueryString: this.settingsForm.value.includeQueryString && this.settingsForm.value.includeQueryString.split(/\r?\n/) || [],
      disablePageCache: this.disablePageCache,
      disableCdn: this.disableCdn
    };
    this._cloudflareService.addUpdateCacheRules(this.websiteId, settingsValues)
      .pipe(
        filter((response: DbResponse): boolean => !!response),
        first()
      ).subscribe((response: DbResponse): void => {
        this.loading = false;
        if (response.success) {
          this.sendEvent();
          const _settingsValues = {
            bypassCookie: this.settingsForm.value.bypassCookie.split(/\r?\n/),
            bypassPageUrlRegex: this.settingsForm.value.bypassPageUrlRegex.split(/\r?\n/),
            includeQueryString: this.settingsForm.value.includeQueryString.split(/\r?\n/)
          };
          this._store.dispatch(new fromStore.SetSettingsValues(
            {
              websiteId: this.websiteId,
              settingsValues: _settingsValues,
            }));
          NotifierComponent.notify(new Notification('Saved successfully', NotificationType.SUCCESS));
        }
        else {
          NotifierComponent.notify(new Notification('Something Went Wrong...', NotificationType.DANGER));
        }
      });
  }

  public sendEvent(): void {
    const analyticsData = {
      eventCategory: 'Dashboard Action',
      eventAction: 'Full page cache settings Save',
      eventLabel: 'Cloudflare',
      websiteId: this.websiteId
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }
}
